<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-12">
              <b-card-body id="login-form">
                <b-form>
                  <h1>
                    {{prefix}}管理介面 <i class="fa fa-android"></i>
                  </h1>
                  <p class="text-muted">請輸入您的帳號密碼</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="email" 
                                  class="form-control" 
                                  placeholder="帳號（通常是email）" 
                                  v-model.lazy.trim="$v.username.$model"
                                  v-focus
                                  :state="chkState('username')"
                                  aria-describedby="invalidEmailFeedback"/>
                    <b-form-invalid-feedback id="invalidEmailFeedback">請填入有效的帳號</b-form-invalid-feedback>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" 
                                  class="form-control" 
                                  placeholder="密碼" 
                                  v-model.lazy.trim="$v.password.$model"
                                  :state="chkState('password')"
                                  aria-describedby="invalidPasswordFeedback"/>
                    <b-form-invalid-feedback id="invalidPasswordFeedback">密碼最少{{$v.password.$params.minLength.min}}個字母</b-form-invalid-feedback>
                  </b-input-group>
                  <b-row>
                    <b-col cols="3">
                      <b-button variant="primary" class="px-4" @click="submit()">送出</b-button>
                    </b-col>
                    <b-col cols="9" class="text-left text-danger">
                      <i class="cui-user-unfollow"></i> 本系統不開放註冊功能，請洽管理人員索取帳號密碼。
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import { required, minLength, between, email } from 'vuelidate/lib/validators'
import VueNotifications from 'vue-notifications'
import config from '@/config/global'
import notifications from '@/config/notifications'

const encrypt  = config.encrypt;
const decrypt  = config.decrypt;
const api_root = config.api_root;

const generateRandomToken = () => {
  // 使用 36 進位，並串接兩個隨機數來增加長度
  const part1 = Math.random().toString(36).slice(2).toUpperCase();
  const part2 = Math.random().toString(36).slice(2).toUpperCase();
  const part3 = Math.random().toString(36).slice(2).toUpperCase();
  return `${part1}${part2}${part3}`; 
};

const get_access_token = function (username, secret, google_captcha) {
  let auth_token = generateRandomToken();
  let action = `${api_root}/get_token`;
  return fetch(action, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Bearer ' + auth_token
    },
    body: JSON.stringify({
      keyset: 'mqtt',
      access: encodeURIComponent(encrypt(JSON.stringify({username, secret, google_captcha}))),
      bring_navs: true
    })
  });
};//eo get_access_token

let getUrlParameter = function getUrlParameter(url) {
    var sPageURL = url.substring(url.indexOf('?')+1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i,
        rlt={};


    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        rlt[sParameterName[0]] = sParameterName[1];
    }

    return rlt;
};//eo getUrlParameter

export default {
  name: 'Login',
  
  notifications,

  beforeMount() {
    let pre_error = this.$state.$get('error');
    let app       = this;

    if(pre_error === config.error.INVALID_USER){
      this.showError({message:'請先登入', title:'使用者尚未通過驗證'});
      this.$state.$del('error');
      return false;
    }

    if(location.hash){
      let get_params = getUrlParameter(location.hash);

      if(!get_params.ccid){
        return;
      }

      let params = {
        ccid: get_params.ccid
      };

      this.$state.$set('ccid', decodeURIComponent(get_params.ccid));

      if(get_params && get_params.ccid){
        let action = `${config.admin_root}/get_company`;
        fetch(action, {
          method: 'POST',
          headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + generateRandomToken()
          },
          body: JSON.stringify(params)
        }).then(res => res.json()).then(result => {
          if(result && result.company && result.company.name){
            app.prefix = result.company.name;

            this.$state.$set('company_name', result.company.name);
          }
        }).catch(error => {
        });
      }
    }

  },//eo beforeMount

  data() {
    return {
      username: '',
      password: '',
      prefix:   ''
    };
  },//eo data

  methods: {
    submit(){
      // console.info('submit');
      let app = this;

      this.$v.$touch();

      if (this.$v.$invalid) {
        this.showError({message:'請輸入您的帳號密碼', title:'登入訊息錯誤'});
        return false;
      }

      let after = (google_captcha) => {
        google_captcha = google_captcha || null;

        let get_token = get_access_token.apply(this, [this.username, this.password, google_captcha]);
        get_token.then(res => res.json()).then(user_token => {
          if(!user_token.success){
            app.showWarn({
              message:user_token.message, 
              title:'服務端錯誤'
            });
            return false;
          } else {
            app.showSuccess({
              message: '歡迎使用',
              title: '登入成功'
            });

            this.$state.$set('adminuser', user_token);

            let ccid = this.$state.$get('ccid');

            // console.info('ccid:', ccid);

            if (user_token.ccid) {
              ccid = `${user_token.ccid}`;
            }

            if(ccid && !user_token.sii){
              this.$state.$set('ccff', ccid);
            } else {
              //console.info('role_id:', user_token.role_id);
              if(user_token.role_id && user_token.role_id == 1) { //role_id = 1 is 訪客
                this.$state.$set('ccff', ccid);
              } else {
                this.$state.$set('ccff', 'N/A');
              }
            }

            if(user_token.after_login_page){
              this.$router.push(user_token.after_login_page);
            } else {
              this.$router.push('/dashboard/home');
            }
          }
        }).catch(error => {
          console.info('user_token error:', error);
          app.showWarn({
            message:'伺服器無回應，請稍後再試', 
            title:'服務端錯誤'
          });
          return false;
        });
      }

      if(config.captcha){
        grecaptcha.execute(config.captcha_key, {action: 'login'})
        .then(function(token) {
          // console.info('grecaptcha.token:', token);
          after(token);
        });
      } else {
        after();
      }
    },
    chkState(val) {
      const field = this.$v[val];
      return !field.$dirty || !field.$invalid;
    },
  },//eo methods

  validations: {
    username: {
      //email,
      required,
      minLength: minLength(4)
    },
    password: {
      required,
      minLength: minLength(5),
    }
  }//eo validations
}
</script>

<style>
.card-body{
  padding: 1.25rem !important;
}
</style>
  